<template>
  <!--模板完全不变，直接沿用之前的template和style-->
  <div class="user-set main-panel large">
    <h1 class="panel-title">产品资料</h1>
    <div class="top">
      <div class="form">
        <div class="row" style="width: 130%">
          <div class="item col-1" style="padding-left: 15px">
            <div class="label" require>品名编号</div>
            <label
              ><input type="text" class="cg-input" v-model="pmname"
            /></label>
          </div>
          <div class="item col-1">
            <div class="label">幅宽：</div>
            <label><input type="text" class="cg-input" v-model="width" /></label
            ><span style="color: #777; font-size: 14px; font-weight: 500"
              >cm</span
            >
          </div>
          <div class="item col-1">
            <div class="label">克重：</div>
            <label
              ><input type="text" class="cg-input" v-model="weight" /></label
            ><span style="color: #777; font-size: 15px; font-weight: 500"
              >g/㎡</span
            >
          </div>
          <div class="item col-1">
            <div class="label">成份：</div>
            <label
              ><input
                maxlength="120"
                type="text"
                class="cg-input"
                v-model="ingredients"
            /></label>
          </div>
          <div class="item col-1">
            <div class="label">量化：</div>
            <label
              ><input type="text" class="cg-input" v-model="quantify" /></label
            ><span style="color: #777; font-size: 15px; font-weight: 500"
              >m/kg</span
            >
          </div>
        </div>
        <div class="row" style="width: 140%">
          <div class="item col-1">
            <div class="label">纱支：</div>
            <label
              ><input type="text" class="cg-input" v-model="yarnCount"
            /></label>
          </div>
          <div class="item col-1">
            <div class="label">密度：</div>
            <label
              ><input type="text" class="cg-input" v-model="density"
            /></label>
          </div>
          <div class="item col-1">
            <div class="label">规格：</div>
            <label
              ><input type="text" class="cg-input" v-model="specification"
            /></label>
          </div>
          <div class="item col-1">
            <div class="label">备注：</div>
            <label
              ><input type="text" class="cg-input" v-model="remark"
            /></label>
          </div>
          <div class="item col-1" style="width: 400px">
            <label class="label" require>面料类别</label>
            <el-select
              v-model="mllist"
              placeholder="请选择面料类别"
              style="width: 100%"
              clearable
              filterable
              multiple
              collapse-tags
            >
              <el-option
                v-for="item in mllists"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="item col-1">
            <div class="form-options">
              <el-button size="small" class="custom-btn" @click="add"
                >新增</el-button
              >
            </div>
          </div>
          <div class="item col-1">
            <div class="form-options">
              <el-button size="small" class="custom-btn" @click="getlist"
                >查询</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-table
      :data="list"
      height="500px"
      border
      style="width: 100%"
      class="custom-table"
    >
      <el-table-column type="index" align="center" width="55" label="序号" />
      <el-table-column
        align="center"
        width="120"
        prop="name"
        show-overflow-tooltip
        label="品名编号"
      />
      <el-table-column
        align="center"
        prop="width"
        width="120"
        label="幅宽"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        prop="weight"
        width="120"
        label="克重"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        prop="ingredients"
        width="120"
        label="成份"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        width="120"
        prop="quantify"
        label="量化"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        width="120"
        prop="yarnCount"
        label="纱支"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        width="120"
        prop="density"
        label="密度"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        width="120"
        prop="specification"
        label="规格"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        width="200"
        show-overflow-tooltip
        prop="remark"
        label="备注"
      />
      <el-table-column align="center" label="面料类别" show-overflow-tooltip>
        <template #default="scope">
          <div class="options">
            {{ getname(scope.row.fabricCategoryList) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template #default="scope">
          <div class="options">
            <i
              class="update-icon el-icon-edit"
              title="修改"
              @click="up(scope.row)"
            ></i>
            <el-popconfirm
              title="确认删除吗?"
              confirmButtonText="确认"
              cancelButtonText="取消"
              @confirm="delUser(scope.row.id)"
            >
              <template #reference>
                <i class="del-icon el-icon-close" title="删除"></i>
              </template>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="修改" center width="366px" v-model="dialogTableVisible">
      <div class="update-view">
        <div class="item">
          <span class="label">品名编号：</span>
          <label
            ><input
              style="margin-left: 15px"
              type="text"
              class="cg-input"
              v-model="uppmname"
          /></label>
        </div>
        <div class="item">
          <span class="label">幅宽：</span>
          <label><input type="text" class="cg-input" v-model="upwidth" /></label
          ><span>cm</span>
        </div>
        <div class="item">
          <span class="label">克重：</span>
          <label
            ><input type="text" class="cg-input" v-model="upweight" /></label
          ><span style="font-size: 15px">g/㎡</span>
        </div>
        <div class="item">
          <span class="label">面料类别：</span>
          <label style="margin-left: 15px">
            <el-select
              v-model="upfabricCategoryId"
              placeholder="请选择面料类别"
              style="width: 100%"
              clearable
              filterable
              multiple
              collapse-tags
            >
              <el-option
                v-for="item in mllists"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </label>
        </div>
        <div class="item">
          <span class="label">量化：</span>
          <label
            ><input type="text" class="cg-input" v-model="upquantify" /></label
          ><span>m/kg</span>
        </div>
        <div class="item">
          <span class="label">纱支：</span>
          <label
            ><input type="text" class="cg-input" v-model="upyarnCount"
          /></label>
        </div>
        <div class="item">
          <span class="label">密度：</span>
          <label
            ><input type="text" class="cg-input" v-model="updensity"
          /></label>
        </div>
        <div class="item">
          <span class="label">规格：</span>
          <label
            ><input type="text" class="cg-input" v-model="upspecification"
          /></label>
        </div>
        <div class="item">
          <span class="label">备注：</span>
          <label
            ><input type="text" class="cg-input" v-model="upremark"
          /></label>
        </div>
        <div class="item">
          <span class="label">成份：</span>
          <label
            ><input type="text" class="cg-input" v-model="upingredients"
          /></label>
        </div>
        <div class="footer">
          <el-button class="custom-btn" size="small" @click="save"
            >保存</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, getCurrentInstance } from "vue";
import { useStore } from "vuex";
import { ElMessage } from "element-plus";

const { proxy } = getCurrentInstance();
const $api = proxy.$api;

const store = useStore();
const userid = ref("");
const mllist = ref([]);
const mllists = ref([]);
const width = ref("");
const weight = ref("");
const ingredients = ref("");
const quantify = ref("");
const remark = ref("");
const pmname = ref("");
const yarnCount = ref("");
const density = ref("");
const specification = ref("");
const list = ref([]);
//弹窗相关
const dialogTableVisible = ref(false);
const uppmname = ref("");
const upid = ref("");
const upwidth = ref("");
const upweight = ref("");
const upingredients = ref("");
const upquantify = ref("");
const upremark = ref("");
const upyarnCount = ref("");
const updensity = ref("");
const upspecification = ref("");
const upfabricCategoryId = ref([]);

// 品名编号校验正则：允许中文、字母、数字、空格 + - \ # %
const pmNameReg = /^[a-zA-Z0-9\u4e00-\u9fa5 +\\\-#%]*$/;

// 保存草稿到sessionStorage
const saveDraft = () => {
  const draft = {
    pmname: pmname.value,
    width: width.value,
    weight: weight.value,
    ingredients: ingredients.value,
    quantify: quantify.value,
    remark: remark.value,
    yarnCount: yarnCount.value,
    density: density.value,
    specification: specification.value,
    mllist: mllist.value,
  };
  sessionStorage.setItem("productDraft", JSON.stringify(draft));
};
// 读取草稿回填
const loadDraft = () => {
  const str = sessionStorage.getItem("productDraft");
  if (str) {
    try {
      const draft = JSON.parse(str);
      pmname.value = draft.pmname || "";
      width.value = draft.width || "";
      weight.value = draft.weight || "";
      ingredients.value = draft.ingredients || "";
      quantify.value = draft.quantify || "";
      remark.value = draft.remark || "";
      yarnCount.value = draft.yarnCount || "";
      density.value = draft.density || "";
      specification.value = draft.specification || "";
      mllist.value = draft.mllist || [];
    } catch (e) {
      sessionStorage.removeItem("productDraft");
    }
  }
};
//清空草稿（新增成功后清空）
const clearDraft = () => {
  sessionStorage.removeItem("productDraft");
};
//合并数组名
const getname = (row) => {
  console.log(row, "aaaa");
  if (row) {
    let text = "";
    for (let index = 0; index < row.length; index++) {
      text += row[index].name + ",";
    }
    if (text) {
      text = text.slice(0, -1);
    }
    console.log(text, "最终返回的数字");
    return text;
  } else {
    return "";
  }
};
//获取面料类别
const getlists = async () => {
  const res = await $api.BasicData.get(userid.value);
  console.log(res.data.code);
  if (res.data.code == 200) {
    mllists.value = res.data.data.list;
    console.log(list.value, "返回的列表是什么格式");
  } else {
    ElMessage.error("网络错误");
    mllists.value = [];
  }
};
//获取产品资料
const getlist = async () => {
  const sendata = {
    name: pmname.value,
    width: width.value, //幅宽
    weight: weight.value, //克重
    ingredients: ingredients.value, //成分
    quantify: quantify.value, //量化
    remark: remark.value, //备注
    fabricCategoryIds: mllist.value.map((item) => item).join(","),
    yarnCount: yarnCount.value, //纱支
    density: density.value, //密度
    specification: specification.value, //规格
  };
  console.log(mllist.value, "你这个参数是什么");

  const res = await $api.BasicData.gets(sendata);
  console.log(res.data.code);
  if (res.data.code == 200) {
    list.value = res.data.data.list;
    console.log(list.value, "返回的列表是什么格式");
  } else {
    ElMessage.error("网络错误");
    list.value = [];
  }
};

//删除产品资料
const delUser = async (id) => {
  const sendata = { id: id };
  const res = await $api.BasicData.dels(sendata);
  if (res.data.code == 200) {
    ElMessage.success("删除成功");
    getlist();
  } else {
    ElMessage.error("网络错误");
  }
};
//新增产品资料
const add = async () => {
  if (pmname.value == "") {
    ElMessage.warning("品名编号不能为空");
    return;
  }
  if (!pmNameReg.test(pmname.value)) {
    ElMessage.warning("产品编号不能有非法符号，仅允许：空格 + - \\ # %");
    return;
  }
  if (pmname.value.length > 25) {
    ElMessage.warning("品名编号最多25个字");
    return;
  }
  if (mllist.value.length == 0) {
    ElMessage.warning("面料类别不能为空");
    return;
  }
  const sendata = {
    name: pmname.value, //品名编号
    width: width.value == "" ? width.value : width.value + "cm", //幅宽
    weight: weight.value == "" ? weight.value : weight.value + "g/㎡", //克重
    ingredients: ingredients.value, //成分
    quantify: quantify.value == "" ? quantify.value : quantify.value + "m/kg", //量化
    remark: remark.value, //备注
    yarnCount: yarnCount.value, //纱支
    density: density.value, //密度
    specification: specification.value, //规格
    fabricCategoryIds: mllist.value, //面料类别
  };
  console.log(sendata, "看看参数是否正确");
  const res = await $api.BasicData.adds(sendata);
  if (res.data.code == 200) {
    pmname.value = "";
    weight.value = "";
    width.value = "";
    ingredients.value = "";
    quantify.value = "";
    remark.value = "";
    yarnCount.value = "";
    specification.value = "";
    density.value = "";
    mllist.value = [];
    clearDraft(); //新增成功，清除草稿
    ElMessage.success("新增成功");
    getlist();
  } else {
    ElMessage.error("网络错误");
  }
};
//打开修改弹窗
const up = async (row) => {
  dels();
  uppmname.value = row.name;
  upid.value = row.id;
  upwidth.value = row.width?.replace(/cm/g, "").trim() || "";
  upweight.value = row.weight?.replace(/["]?g\/㎡/g, "").trim() || "";
  upingredients.value = row.ingredients;
  upremark.value = row.remark;
  upquantify.value = row.quantify?.replace(/["]?m\/kg/g, "").trim() || "";
  upfabricCategoryId.value = getid(row.fabricCategoryList);
  dialogTableVisible.value = true;
  upyarnCount.value = row.yarnCount;
  updensity.value = row.density;
  upspecification.value = row.specification;
};
//获取修改的所有id
const getid = (row) => {
  let arrs = [];
  for (let index = 0; index < row.length; index++) {
    arrs.push(row[index].id);
  }
  console.log(arrs, "数组");
  return arrs;
};
//清除修改弹窗残留数据
const dels = () => {
  upid.value = "";
  uppmname.value = "";
  upweight.value = "";
  upwidth.value = "";
  upingredients.value = "";
  upfabricCategoryId.value = [];
  upremark.value = "";
  upquantify.value = "";
  upspecification.value = "";
  upyarnCount.value = "";
};
//修改产品资料
const save = async () => {
  if (uppmname.value == "") {
    ElMessage.warning("品名编号不能为空");
    return;
  }
  if (!pmNameReg.test(uppmname.value)) {
    ElMessage.warning("产品编号不能有非法符号，仅允许：空格 + - \\ # %");
    return;
  }
  if (uppmname.value.length > 25) {
    ElMessage.warning("品名编号最多25个字");
    return;
  }
  const sendata = {
    id: upid.value, //id
    name: uppmname.value, //产品编号
    width: upwidth.value == "" ? upwidth.value : upwidth.value + "cm", //幅宽
    weight: upweight.value == "" ? upweight.value : upweight.value + "g/㎡", //克重
    ingredients: upingredients.value, //成分
    quantify:
      upquantify.value == "" ? upquantify.value : upquantify.value + "m/kg", //量化
    remark: upremark.value, //备注
    fabricCategoryIds: upfabricCategoryId.value,
    yarnCount: upyarnCount.value, //纱支
    density: updensity.value, //密度
    specification: upspecification.value, //规格
  };
  console.log("参数是否正确", sendata);
  try {
    const res = await $api.BasicData.updatas(sendata);
    if (res.data.code == 200) {
      dialogTableVisible.value = false;
      ElMessage.success("修改成功");
      getlist();
    } else {
      ElMessage.error("修改失败：" + (res.data.msg || "未知错误"));
    }
  } catch (error) {
    ElMessage.error("网络错误，修改失败");
  }
};

onMounted(async () => {
  // 页面进来读取本地草稿回填表单
  loadDraft();
  userid.value = store.state.frontUserInfo.id;
  await getlists();
  await getlist();
});

onBeforeUnmount(() => {
  saveDraft();
});
</script>


<style lang="scss" scoped>
@import "./baseProduct.scss";
// 表格滚动条变粗
:deep(.el-table__body-wrapper) {
  // 竖向滚动条宽度
  &::-webkit-scrollbar {
    width: 14px; // 竖条粗细
    height: 14px; // 横条粗细
  }
  // 滚动条滑块
  &::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 6px;
  }
  // 滚动条轨道背景
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
}
:deep(.custom-btn) {
  background-color: #ffae00 !important;
  border-color: #ffae00 !important;
  color: #333;
}
:deep(.el-dialog) {
  margin-top: 15vh !important;
}
:deep(.el-table .cell) {
  font-size: 15px;
}
:deep(.el-dialog--center .el-dialog__body) {
  height: 570px !important;
}
.main-panel.large {
  background-color: #fff;
}
.panel-title {
  color: #666;
}
:deep(.el-select .el-input__inner) {
  background-color: #fff;
}
:deep(.el-select .el-input__inner:focus) {
  background-color: #fff;
}
:deep(.custom-table) {
  background-color: #fff !important;
  .el-table__header-wrapper {
    background-color: #fff !important;
    .el-table__header {
      background-color: #fff !important;
      th {
        background-color: #fff !important;
      }
    }
  }
  .el-table__body-wrapper {
    background-color: #fff !important;
    .el-table__body {
      background-color: #fff !important;
      td {
        background-color: #fff !important;
      }
    }
  }
}
:deep(.el-dialog--center) {
  background-color: #fff !important;
}
</style>
